import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FacialRecognitionService, MemberQuery } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgb-facial-recognition-uploader-button',
  templateUrl: './facial-recognition-uploader-button.component.html',
  styleUrl: './facial-recognition-uploader-button.component.scss',
})
export class FacialRecognitionUploaderButtonComponent {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() facialRecognitionButtonType: number = 1;
  @Input() smallUploadButton: boolean = false;
  @Output() nextStepChange = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  @Output() takePhoto = new EventEmitter();
  @Output() uploadedImageEvent = new EventEmitter();
  @Output() capturePhoto = new EventEmitter();
  @Output() retakePhoto = new EventEmitter();
  @Output() submitphoto = new EventEmitter();

  constructor(
    private facialRecognitionService: FacialRecognitionService,
    private memberQuery: MemberQuery,
    private modalService: NgbModal
  ) {}

  changeImageFile(e: Event) {
    const input = e.target as HTMLInputElement;
    const files = input.files;

    if (files) {
      let file = files[0];
      if (this.formData.value) this.formData.setValue(null);
      this.formData.setValue(file);

      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = reader.result as string;
        this.uploadedImage.setValue(base64String);
      };
      reader.readAsDataURL(file);

      const newInput = document.createElement('input');
      newInput.id = 'uploadedImageInput';
      newInput.hidden = true;
      newInput.accept = 'image/*';
      newInput.type = 'file';
      newInput.addEventListener('change', this.changeImageFile.bind(this));

      // Replace the old input
      input.parentNode?.replaceChild(newInput, input);
      this.uploadedImageEvent.emit();
    }
  }

  nextStep() {
    this.nextStepChange.emit();
  }

  previousStep() {
    this.previousStepChange.emit();
  }

  closeModal() {
    this.facialRecognitionService.fetchFacialImage(this.memberQuery.getUserContext().memberId);
    this.modalService.dismissAll();
  }
}
